import * as URLConfig from "@frameworks/web/config/domain";
import salesConfig from "@frameworks/salesjourney/config/domain";
import { urlConstructor } from "@frameworks/web/config/domain";
import { microService } from "@adapters/infrastructures/urlConfig/SalesJourney/microServiceBase";
var config = URLConfig.config;
var orderbook = "orderbook/";
var mutualFundOrderBookConfigURL = {
    // getMutualFundOrderBook: `${config.jmw}${config.app_mf}${orderbook}`,
    // getMutualFundOrderBookSummary: `${config.jmw}${config.app_mf}${orderbook}summary`,
    // getMFOrderBookPastInstallments: `${config.jmw}${config.app_mf}${orderbook}past-installment`,
    // getMutualFundOrderBookTimeline: `${config.jmw}${config.app_mf}${orderbook}timeline`,
    // getMFOrderbookTransactionType: `${config.jmw}${config.app_mf}${orderbook}transaction-type`,
    downloadMFOrderBookExcelFile: urlConstructor(config.app_mf, orderbook, "excel"),
    // downloadMFOrderBookExcelFile: `${config.jmw}${config.app_mf}${orderbook}excel`,
    getMFOrderbookTransactionType: urlConstructor(config.app_mf, orderbook, "transaction-type"),
    // getMFOrderbookTransactionType:
    //   config.jmw + config.app_mf + "orderbook/transaction-type",
    consentResendOTP: urlConstructor(config.app_mf, "consent/", "resend"),
    // consentResendOTP: `${config.jmw}${config.app_mf}consent/resend`,
    resendPaymentLink: urlConstructor(config.app_mf, "pay/", "resend"),
    // resendPaymentLink: `${config.jmw}${config.app_mf}pay/resend`,
    getMFOrderBookCtaDetail: urlConstructor(config.app_mf, orderbook, "cta-detail/v1"),
    // getMFOrderBookCtaDetail: `${config.jmw}${config.app_mf}${orderbook}cta-detail/v1`,
    //encrypted Version
    getMutualFundOrderBook: urlConstructor(config.app_mf, orderbook, "v1"),
    // getMutualFundOrderBook: config.jmw + config.app_mf + "orderbook/v1",
    getMFOrderBookPastInstallments: urlConstructor(config.app_mf, orderbook, "v1/past-installment"),
    // getMFOrderBookPastInstallments:
    //   config.jmw + config.app_mf + "orderbook/v1/past-installment",
    getMutualFundOrderBookTimeline: urlConstructor(config.app_mf, orderbook, "v1/timeline"),
    // getMutualFundOrderBookTimeline:
    //   config.jmw + config.app_mf + "orderbook/v1/timeline",
    // downloadMFOrderBookExcelFile: config.jmw + config.app_mf + "orderbook/v1/excel",
    getMutualFundOrderBookSummary: urlConstructor(config.app_mf, orderbook, "v1/summary"),
    // getMutualFundOrderBookSummary:
    //   config.jmw + config.app_mf + "orderbook/v1/summary",
    getTrasnferInTabData: salesConfig.apiBase + microService.casAdvisoryService + "arn/orderBook",
};
export default mutualFundOrderBookConfigURL;
